import React from 'react';
import { makeStyles } from '@mui/styles';
import {
    Container,
    ButtonGroup,
    ActiveButton,
    MaintenanceButton,
} from './styles';
import { i18n } from '../../translate/i18n';

const EquipmentStatusButtons = ({ active, maintenance, handleActiveButton, handleMaintenance, maintenanceFeatureFlag = true}) => {
    const useStyles = makeStyles({
        activeButton: {
            '&:hover': {
                backgroundColor: active ? '#585858' : 'green',
            }
        }, 
        maintenanceButton: {
            '&:hover': {
                backgroundColor: maintenance ? 'darkblue' : '#0363c3',
            }
        }
    });
    const classes = useStyles();

    return (<Container>
        <ButtonGroup>
            <ActiveButton className={classes.activeButton} variant="contained" onClick={handleActiveButton} color="primary" active={active ? 1 : 0} >
                {active ? i18n.t('activeButtonEquipStatusBtn.true') : i18n.t('activeButtonEquipStatusBtn.false')} {i18n.t('activeButtonEquipStatusBtn.label')}
            </ActiveButton>
            {active && !maintenanceFeatureFlag &&
            <MaintenanceButton className={classes.maintenanceButton}  variant="contained" onClick={handleMaintenance} color="primary" maintenance={maintenance ? 1 : 0}>
                {maintenance ? i18n.t('maintenanceButtonEquip.true') : i18n.t('maintenanceButtonEquip.false')} {i18n.t('maintenanceButtonEquip.label')}
            </MaintenanceButton>}
        </ButtonGroup>
    </Container>);
};

export default EquipmentStatusButtons;